import { createContext, useContext, useEffect, useState } from "react";
import config from "../config";

let cachedCategories = null;
let pendingPromise = null;

function loadCategories() {
  if (cachedCategories !== null) return Promise.resolve(cachedCategories);
  if (pendingPromise) return pendingPromise;
  pendingPromise = fetch(`${config.BACKEND_BASE_URL}/api/categories`)
    .then((res) => { if (!res.ok) throw new Error(); return res.json(); })
    .then((data) => { cachedCategories = Array.isArray(data) ? data : []; return cachedCategories; })
    .catch(() => { cachedCategories = []; return cachedCategories; });
  return pendingPromise;
}

const CategoriesContext = createContext({ categories: null, error: false });

export function CategoriesProvider({ children }) {
  const [categories, setCategories] = useState(cachedCategories);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (cachedCategories !== null) return;
    loadCategories().then(setCategories).catch(() => setError(true));
  }, []);

  return (
    <CategoriesContext.Provider value={{ categories, error }}>
      {children}
    </CategoriesContext.Provider>
  );
}

export const useCategories = () => useContext(CategoriesContext);
